import { NamedContentEntryText } from '../../components/ContentEntryText/NamedContentEntryText';
import { RobotAvatar } from '../../components/Props/RobotAvatar/RobotAvatar';
import type { ReactNode } from 'react';
import type { ContentEntryRefsKey } from '../../contentEntryRefs/contentEntryRefs';
import { capitalize } from '../string/capitalize';

export enum UserLevels {
  vulnerable = 'Vulnerable',
  determined = 'Determined',
  solid = 'Solid',
  armored = 'Armored',
  unbreakable = 'Unbreakable',
}

const UserLevelsColorMap = {
  [UserLevels.vulnerable]: '#FF6F5A',
  [UserLevels.determined]: '#F8AA30',
  [UserLevels.solid]: '#4C5AFF',
  [UserLevels.armored]: '#3ABF87',
  [UserLevels.unbreakable]: '#6600FF',
};

export type UserLevelDetailsType = Record<
  UserLevels,
  {
    number: number;
    level: ReactNode;
    name: ReactNode;
    introText: ReactNode;
    description: ReactNode;
    image: ReactNode;
    color: string;
  }
>;

export const UserLevelDetails = Object.fromEntries(
  Object.values(UserLevels).map((level, index) => {
    const lvl = capitalize(level);
    const levelKey = `securitySnapshotLevels${lvl}` satisfies ContentEntryRefsKey;
    return [
      level as UserLevels,
      {
        number: index + 1,
        level: <NamedContentEntryText container="span" refKey={levelKey} subKey="levelN" />,
        name: <NamedContentEntryText container="span" refKey={levelKey} subKey="levelName" />,
        introText: <NamedContentEntryText container="span" refKey={levelKey} subKey="bodyHeading" />,
        description: <NamedContentEntryText container="span" refKey={levelKey} subKey="bodyMain" asHtml />,
        image: <RobotAvatar levelId={lvl} />,
        color: UserLevelsColorMap[level as UserLevels],
      },
    ] as const;
  }),
) as unknown as UserLevelDetailsType;
